import { AudioManager } from "./AudioManager";
import { MazeManager } from "./scenes/maze-scene/MazeManager";
import { GameVars } from "./GameVars";

export class Game extends Phaser.Game {

    public static currentInstance: Phaser.Game;

    constructor(config: Phaser.Types.Core.GameConfig) {
        
        super(config);

        Game.currentInstance = this;
    }

    public onBlur(): void {

        super.onBlur();

        if (GameVars.currentScene.scene.key === "MazeScene" && !GameVars.pause) {
            MazeManager.pauseGame();
        }
    
        AudioManager.onBlur();
    }

    public onFocus(): void {

        super.onFocus();

        AudioManager.onFocus();
    }
}
